export default __webpack_public_path__ + "static/media/lock.67c79ce6.png";